import { useIntl } from "react-intl";

import { PaymentDetailsSummaryRow } from "@/components/PaymentDetails/PaymentDetailsSummaryRow";
import { formatCurrency } from "@/utils/currency";

type Props = {
  totalPrice: number;
};

export const PaymentDetailsTotalPriceRow = ({ totalPrice }: Props) => {
  const intl = useIntl();

  return (
    <PaymentDetailsSummaryRow
      label={intl.formatMessage({
        defaultMessage: "Total price",
        description: "Label for the total booking price",
      })}
      value={formatCurrency(totalPrice)}
    />
  );
};
